import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AccountGopInfo } from '@secca/shared/models/account-gop-info';
import { SupplierService } from '@secca/core/services/supplier.service';
import { map } from 'rxjs/operators';
import { DocListItem, SupplierSearchResponse } from '@secca/shared/models/SupplierSearchResponse';

// TODO: Suppliers with agents. A supplier can have an agent in NMS who's
//  account GOP should be used instead of the supplier's own account GOP.

@Injectable({
  providedIn: 'root',
})
export class AccountGopService {
  private readonly accountGopSubject = new BehaviorSubject<AccountGopInfo | null>(null);

  constructor(private readonly supplierService: SupplierService) {}

  getAccountGopInfo(): Observable<AccountGopInfo> {
    return this.accountGopSubject.asObservable();
  }

  updateAccountGopInfo(supplierId: string): void {
    this.accountGop(supplierId).subscribe({
      next: (gop: AccountGopInfo) => this.accountGopSubject.next(gop),
      error: (e) => console.error('Error fetching accountGop:', e)
    });
  }

  public accountGop(supplierId: string): Observable<AccountGopInfo> {
    const query = `freeText=supplierId:${supplierId}`;
    const response = this.supplierService.searchSuppliers(query);
    return response.pipe(
      map((data: SupplierSearchResponse) => {
        const doc = data?.docList?.[0];
        return doc ? this.mapToAccountGopInfo(doc) : null;
      })
    );
  }

  private mapToAccountGopInfo(doc: DocListItem): AccountGopInfo {
    return new AccountGopInfo({
      supplierId: doc.supplierId,
      accompanyingLetter: doc.accompanyingLetter,
      commitmentType: doc.commitmentType,
      commitmentTypeCode: doc.commitmentTypeCode,
      gopLanguage: this.gopLanguage(doc),
      gopMethod: doc.gopMethod,
      gopTemplate: doc.gopTemplate,
    });
  }

  private gopLanguage(doc: DocListItem): string {
    const contacts = doc.contact_list || [];
    const gopContact = contacts.find(ct =>  ct.contact_roles?.some(r => r.includes('IsGopRole')));

    return gopContact?.contact_language || '';
  }
}
